// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__rOync","content":"FAQ_content__-3aUs"};